export const PATTERN_CHAR = '0';
export const MASK_PATTERN_CHAR = '*';
export const MASK_CHAR = '•';
